import React from 'react';
import { View, Text, ViewStyle, TextStyle } from 'react-native';
import { useTheme } from '../context/themeContext';

interface ConfBarProps {
  value: number; // 0.0 – 1.0
  style?: ViewStyle;
}

export default function ConfBar({ value, style }: ConfBarProps) {
  const { theme } = useTheme();
  const { colors, fontSize } = theme;

  const pct = Math.round(value * 100);
  const fillColor =
    value >= 0.8 ? colors.success :
    value >= 0.6 ? colors.warn :
    colors.danger;

  const trackStyle: ViewStyle = {
    display: 'inline-flex' as any,
    width: 40,
    height: 5,
    borderRadius: 3,
    backgroundColor: colors.paper3,
    overflow: 'hidden',
    flexDirection: 'row',
  };

  const fillStyle: ViewStyle = {
    width: `${pct}%` as any,
    height: '100%' as any,
    backgroundColor: fillColor,
  };

  const textStyle: TextStyle = {
    fontSize: fontSize.xs,
    fontFamily: theme.font.mono,
    color: colors.ink3,
    includeFontPadding: false,
    marginLeft: 5,
  };

  return (
    <View
      style={[
        {
          flexDirection: 'row',
          alignItems: 'center',
        },
        style,
      ]}
      accessibilityLabel={`Confidence ${pct}%`}
    >
      <View style={trackStyle}>
        <View style={fillStyle} />
      </View>
      <Text style={textStyle}>{value.toFixed(2)}</Text>
    </View>
  );
}
